// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_authentication_authentication_module_ts":"7232095a1fb0a306","node_modules_echarts_index_js":"3f3e4a6328f58a8a"}[chunkId] + ".js";
};